import { ImageProps, ImageStyle } from '@betty/moonlight';
import { DepositPromoRewardTarget } from '../../../../state/deposit/deposit.types';

export const PROMO_IMAGES: Partial<
  Record<DepositPromoRewardTarget, ImageProps<ImageStyle>['name']>
> = {
  Bonus: 'wallet.promoCash',
  Cash: 'wallet.promoCash',
  Coins: 'wallet.promoCoins',
  InstantWheel: 'wallet.promoWheel',
};
